import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AppService } from '../../app.service';
import { AuthenticationService } from '../shared/authentication.service';
import { LoaderEvent } from '../../shared/message.event';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'modal',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.css'],
    providers: [AuthenticationService, LoaderEvent],
    exportAs: 'forgot'
})
export class ForgetPasswordComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    private vendor = {
        emailId: '',
        password: ''
    };
    private authenticationService;
    private popUpMessage: string;
    private validateEmailClass = '';
    private utilityFunctions = new UtilityFunctions();

    constructor(private router: Router, private _authenticationService: AuthenticationService, private loaderEvent: LoaderEvent, private appService: AppService) {
        this.authenticationService = _authenticationService;
        this.popUpMessage = ''
    }

    ngOnInit() {
    }

    /**
     * Display popup for forgot password
     */

    public showChildModal(): void {
        try {
            this.validateEmailClass = '';
            this.childModal.config.backdrop = false;
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Hide popup of forgot password
     */

    public hideChildModal(): void {
        try {
            this.vendor.emailId = '';
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Send password to specific email id.
     * 
     * @param vendor's email id
     * 
     * @response got mail to vendor
     */
    sendMailForForgotPassword(popUpObj) {
        try {
            if (this.vendor.emailId) {
                if (this.validateEmail(this.vendor.emailId)) {
                    this.loaderEvent.fire(false);
                    this.authenticationService.forgotPassword(this.vendor).then((result: any) => {
                        if (result.status === 'SUCCESS') {
                            this.popUpMessage = result.message;
                            popUpObj.showChildModal();
                        } else {
                            this.popUpMessage = result.message;
                            popUpObj.showChildModal();
                        }
                        this.loaderEvent.fire(true);
                    }).catch((err) => {
                        console.log(err);
                        this.loaderEvent.fire(true);
                    });
                    this.vendor.emailId = '';
                } else {
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Hide popup on ok click
     */
    onNotify(bool: boolean) {
        try {
            this.hideChildModal();
        } catch (e) {
            console.log(e);
        }
    }
    
    /**
     * Validate email id.
     * 
     * @param email id
     * 
     * @response got red bottom line for invalid email id
     */
    validateEmail(email) {
        try {
            let validEmail = this.utilityFunctions.validateEmail(email);
            if (validEmail) {
                this.validateEmailClass = ''
            } else {
                this.validateEmailClass = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            }
            return validEmail;
        } catch (e) {
            console.log(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/forget-password/forget-password.component.ts